import React from 'react';

const TextArea = (props) => {
    return (
        <>
            <textarea
                maxLength={props.maxLength}
                className='notes-area-form form-control'
                onChange={(e) => props.onChange(e.target.value)}
                id='notes'
                value={props.value}
                placeholder={props.placeholder}>                    
            </textarea>
            {props.error && <div className='textarea-error'>{props.error}</div>}        
        </>
    );
};
export default TextArea;
